import PropTypes from "prop-types";
import React from "react";
import { IconButton, Box, Tooltip } from "@mui/material";
// import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import PrintIcon from "@mui/icons-material/PrintOutlined";
// import ImportIcon from "@mui/icons-material/SaveAlt";
import ExportIcon from "../Icons/ExportIcon";
// import SearchIcon from "@mui/icons-material/Search";
import ReactToPrint from "react-to-print";

const CalendarQuickActions = ({
  userPermissions,
  onSettingsModalOpenChange,
  onExportModalOpenChange,
  calendarRef
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      justifyContent={{ xs: "center", sm: "unset" }}
    >
      {/* TODO: Uncomment when backend functionality for buttons is implemented  
      <Box width={160}>
        <TextField
          InputProps={{
            startAdornment: <SearchIcon />,
            placeholder: "Search Events",
            disableUnderline: true
          }}
        />
        </Box> */}
      <Box display="flex">
        {!(userPermissions.silver || userPermissions.validate) && (
          <Tooltip title="Print">
            <div>
              <ReactToPrint
                trigger={() => {
                  // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                  // to the root node of the returned component as it will be overwritten.
                  return (
                    <IconButton size="large">
                      <PrintIcon />
                    </IconButton>
                  );
                }}
                content={() => calendarRef.current}
              />
            </div>
          </Tooltip>
        )}
        <Tooltip title="Export">
          <IconButton
            onClick={() => {
              onExportModalOpenChange(true);
            }}
            size="large"
          >
            <ExportIcon />
          </IconButton>
        </Tooltip>
        {/* TODO: Uncomment when backend functionality for buttons is implemented
        !(userPermissions.silver || userPermissions.validate) && (
          <Tooltip title="Import">
            <IconButton
              onClick={() => {
                onImportModalOpenChange(true);
              }}
            >
              <ImportIcon />
            </IconButton>
            </Tooltip> 
          <Tooltip title="Calendar Settings">
            <IconButton
              onClick={() => {
                onSettingsModalOpenChange(true);
              }}
            >
              <SettingsIcon />
            </IconButton>
            </Tooltip>) */}
      </Box>
    </Box>
  );
};

export default CalendarQuickActions;

CalendarQuickActions.propTypes = {
  userPermissions: PropTypes.any,
  classes: PropTypes.any,
  /**
   * Called when the export modal is open or closed
   */
  onExportModalOpenChange: PropTypes.func,
  /**
   * Called when the import modal is open or closed
   */

  onImportModalOpenChange: PropTypes.func,
  /**
   * Called when the settings modal is open or closed
   */
  onSettingsModalOpenChange: PropTypes.func
};
